(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ww-reimbursement-calculator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input',event=>{const root=event.target.closest('[data-refund]');if(!root)return;const kwh=Number(root.querySelector('[data-refund-range]').value);const custom=root.querySelector('[data-refund-mode]:checked').value==='custom';root.querySelector('[data-refund-custom]').hidden=!custom;const price=custom?Number(root.querySelector('[data-refund-price]').value.trim().replace(',','.')):34;const valid=Number.isFinite(price)&&price>0;const money=value=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(value);root.querySelector('[data-refund-kwh]').textContent=kwh;root.querySelector('[data-refund-month]').textContent=valid?money(kwh*price/100):'–';root.querySelector('[data-refund-year]').textContent=valid?money(kwh*price/100*12):'–';root.querySelector('[data-refund-formula]').textContent=valid?kwh+' kWh × '+money(price/100)+' = '+money(kwh*price/100):'Bitte einen gültigen Strompreis eingeben.';});
  } catch(e) { console.error(e); }
})();

})();
